// Para volver a la variable de entorno:
// export const LICENSE_KEY = process.env.REACT_APP_LICENSE_KEY;
export const LICENSE_KEY = "30233eb2337a94a7243a6eaf0742dec5Tz0xMjg2NDgsRT0xODA5MDAwMDAwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
export const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY;
export const X_API_KEY = process.env.REACT_APP_X_API_KEY;
export const APLICACION_COD = process.env.REACT_APP_APLICACION_COD;
export const SERVICE_URL = process.env.REACT_APP_SERVICE_URL;
